import { z } from "zod";
// ===== REQUEST SCHEMAS =====
export const EarlyClockInRequestSchema = z.object({
    shiftId: z.uuid(),
    notes: z.string().max(500).optional(),
});
// ===== RESPONSE SCHEMAS =====
export const EarlyClockInResponseSchema = z.object({
    shift: z.object({
        id: z.uuid(),
        startTime: z.iso.datetime(),
        endTime: z.iso.datetime(),
        locationId: z.uuid(),
        jobRoleFamilyId: z.uuid().nullable(),
    }),
    timecard: z.object({
        id: z.uuid(),
        status: z.string(),
    }),
    approvalRequestId: z.uuid(),
});
